import React, { useState } from 'react'

import { env } from '@/core/environments'
import { Badge, type BadgeProps } from '@/shared/components/atoms/Badge/Badge'
import Icon from '@/shared/components/atoms/Icon'
import { cn } from '@/shared/utils/helpers'

interface EnvironmentIndicatorProps {
	/**
	 * If false, the indicator will not render in production.
	 * Defaults to false (not shown in production).
	 */
	showInProduction?: boolean
}

export const EnvironmentIndicator: React.FC<EnvironmentIndicatorProps> = ({
	showInProduction = false,
}) => {
	const [dismissed, setDismissed] = useState<boolean>(false)

	if (dismissed) return null
	if (env.NODE_ENV === 'production' && !showInProduction) return null

	// Determine badge variant based on the environment
	const getBadgeVariant = (): BadgeProps['variant'] => {
		switch (env.NODE_ENV) {
			case 'production':
				return 'secondary'
			case 'development':
				return 'destructive'
			default:
				return 'destructive'
		}
	}

	return (
		<Badge
			variant={getBadgeVariant()}
			className={cn(
				'fixed bottom-2.5 right-2.5 z-50 select-none shadow-sm px-3 py-1 text-xs',
				'backdrop-blur-sm'
			)}
		>
			<span className="flex items-center gap-2">
				<span>
					{env.APP_NAME} - {env.NODE_ENV}
				</span>
				<Icon
					name="x-circle-fill"
					width="16px"
					height="16px"
					onClick={() => setDismissed(true)}
				/>
			</span>
		</Badge>
	)
}
